import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/graphql';
import { select, Store } from '@ngrx/store';
import { selectShoppingCartContext } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';
import { ShoppingCartState } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { translationProvider } from '@ui/nls/translations/translate.directive';
import { ENFORCE_SCREEN_PROTECTION_IN_NATIVE_APP } from '@ui/zalamo-dialog/screen-protection.token';

@Component({
    selector: 'lib-photo-preview',
    templateUrl: './photo-preview.component.html',
    styleUrls: ['./photo-preview.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PhotoPreviewComponent implements OnInit {
  static readonly [ENFORCE_SCREEN_PROTECTION_IN_NATIVE_APP] = true;
  @Input() photoId: string;
  context = ZalamoObject.PublicSession;
  shoppingCartContext$ = this.store.pipe(select(selectShoppingCartContext));

  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));

  constructor(
    private store: Store<{ shoppingCart: ShoppingCartState }>,
    private screenObserver: BreakpointObserver,
    public dialog: ZalamoDialogService,
  ) {}

  ngOnInit(): void {}
}
